import { Language } from './Language';
import { Survey } from './Survey';
import { CharacteristicScore, } from './CharacteristicScore';
import { ScoreWeight } from './ScoreWeight';

export class QuestionText {
    public id: number;
    public value: string;
    public languageId: number;
    public language: Language;
}

export class QuestionOptionText {
    public value: string;
    public languageId: number;
    public language: Language;
}

export class QuestionOption {
    public id: number;
    public questionOptionTexts: QuestionOptionText[];
    public value: number;
    public checked: boolean;
    public sort: number;
    public scoreWeights: ScoreWeight[];
    public visualStyle: string;

    // this property is currently coming from the backend 
    public text: string;
    // public static Text(questionOption: QuestionOption, language: Language): string {
    //     for (var i = 0; i < questionOption.questionOptionTexts.length; i++) {
    //         if (questionOption.questionOptionTexts[i].languageId === language.id) {
    //             return questionOption.questionOptionTexts[i].value;
    //         }
    //     }
    //     return '';
    // }
}

export class Question {
    public id: number;
    public previousQuestionID: number;
    public name: string;
    public questionType: string;
    public surveyID: number;
    public survey: Survey;
    public questionTexts: QuestionText[];
    public questionOptions?: QuestionOption[];
    public characteristicScores: CharacteristicScore[];
    public scoreWeights: ScoreWeight[];
    public sort: number;
    public tempSort: number;
    public value: string; // Used for storing free text responses
    public questionNumber: number; // used to store the number of the question on the page. Set during runtime

    public static Text(question: Question, language: Language): string {
        for (var i = 0; i < question.questionTexts.length; i++) {
            if (question.questionTexts[i].languageId === language.id) {
                return question.questionTexts[i].value;
            }
        }
        return '';
    }
}


// WEBPACK FOOTER //
// ./src/models/Question.tsx